<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"
        defaultHref="/settings/pos-settings/discounts"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Salon Discounts</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="createDiscount()">
        <ion-icon name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccured"
    (click)="loadDiscounts()"
  ></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccured">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <ion-item *ngIf="discounts.count() == 0">
          <div class="no-discounts">No salon discounts</div>
        </ion-item>

        <ion-list *ngIf="discounts.count() > 0">
          <ion-item
            class="discount"
            *ngFor="let discount of discounts; let discountIndex = index;"
            (click)="onDiscountEditHandler(discount, discountIndex)"
          >
            {{ discount.name }}
            <div slot="end">
              {{ discount.amount }} {{ discount.type == 1 ? '%' : '$'}}
            </div>
        </ion-item>
        </ion-list>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
